export default __webpack_public_path__ + "./images/unknown.2883f108.svg";